import { FlowComponentDefinition } from "../../interface/functionalityInterface";
import { OUTLINE_COLOR, renderStraightArrow, renderStraightPulse } from "./renderingUtils";

export const triClampComponent: FlowComponentDefinition = {
  type: "triClamp",
  title: "tri-clamp",
  category: "Connections",
  visualKind: "triClamp",
  defaultColor: "#9ea4ab",
  previewFlow: { from: "left", to: "right" },
  ports: ["left", "right"],
  incomingDirections: ["left"],
  outgoingDirections: ["right"],
  defaults: { size: "2" },
  fields: [
    { key: "size", label: "Size" },
    { key: "color", label: "Color", inputType: "color" },
  ],
  renderGraphic: (context) =>
    context.isHorizontal ? (
      <>
        <line x1="0" y1="50" x2="42" y2="50" stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinecap="round" />
        <line x1="58" y1="50" x2="100" y2="50" stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinecap="round" />
        <line x1="42" y1="18" x2="42" y2="82" stroke={OUTLINE_COLOR} strokeWidth="1.8" strokeLinecap="round" />
        <line x1="58" y1="18" x2="58" y2="82" stroke={OUTLINE_COLOR} strokeWidth="1.8" strokeLinecap="round" />
        {renderStraightArrow(context)}
      </>
    ) : (
      <>
        <line x1="50" y1="0" x2="50" y2="42" stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinecap="round" />
        <line x1="50" y1="58" x2="50" y2="100" stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinecap="round" />
        <line x1="18" y1="42" x2="82" y2="42" stroke={OUTLINE_COLOR} strokeWidth="1.8" strokeLinecap="round" />
        <line x1="18" y1="58" x2="82" y2="58" stroke={OUTLINE_COLOR} strokeWidth="1.8" strokeLinecap="round" />
        {renderStraightArrow(context)}
      </>
    ),
  renderAnimatedFlow: (context) => renderStraightPulse(context),
};
